module.exports = __webpack_public_path__ + "img/sx_head.238faace.png";